import { memo, type ReactNode, useCallback } from 'react';

export type SubSideNavScrollbarProps = {
  children: ReactNode;
  onScrollElement?: (element: HTMLDivElement | null) => void;
};

export const SubSideNavScrollbar = memo(({ children, onScrollElement }: SubSideNavScrollbarProps) => {
  const handleScrollElement = useCallback(
    (element: HTMLDivElement | null) => {
      onScrollElement?.(element);
    },
    [onScrollElement],
  );

  return (
    <div
      className="scrollbar-thin scrollbar-track-gray-2 scrollbar-thumb-gray-7 [&:not(:hover)]:scrollbar-track-transparent flex min-h-0 grow flex-col overflow-y-auto overflow-x-hidden overscroll-contain p-2.5"
      data-testid="SUB_SIDE_NAV_SCROLLBAR"
      ref={handleScrollElement}
    >
      {children}
    </div>
  );
});

SubSideNavScrollbar.displayName = 'SubSideNavScrollbar';
